/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const r=require("./chunkprogressbar/ChunkProgressBar.js"),e=require("./progressbar/ProgressBar.js");exports.ChunkProgressBar=r.ChunkProgressBar;exports.ProgressBar=e.ProgressBar;
